{
  "base": {
    "title": "Something went wrong",
    "subtitle": "Thank you for your patience while we are working on the fix.",
    "redirectLabel": "Go to Homepage",
    "helpCenterLink": "Visit the Help Center"
  }
}
